import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticCard from 'components/v2/card';
import LabelValue from 'components/ui/tailwind/label-value';
import EditButton from '../../../v2/buttons/EditButton';
import 'utils/selectize';

const ConsigneeAccountCard = ({ consignee, onEditAccount }) => {
  const { t } = useTranslation();
  return (
    <CargomaticCard
      className="mb-6"
      header={() => (
        <header
          onClick={() => onEditAccount()}
          className="flex items-center justify-between"
        >
          <h3 className="my-0">{t('ACCOUNT_DETAILS')}</h3>
          <EditButton />
        </header>
      )}
    >
      <LabelValue
        value={`${consignee.first_name} ${consignee.last_name}`}
        icon="user"
      />
      <LabelValue value={consignee.username} icon="lock" />
      <LabelValue value={consignee.phone} icon="phone" />
      <LabelValue value={consignee.email} icon="envelope" />
    </CargomaticCard>
  );
};
export default ConsigneeAccountCard;
